import { isUserLoggedIn } from "../../utils/loggedInControl.js";

function localStorageKeyFactory(postID, isLogged) {
    return `post::${postID}::poll::${isLogged}`;
}

export function setVoteRecord(listicle, voterID) {
    const postID = listicle.dataset.postId;
    localStorage.setItem(localStorageKeyFactory(postID, isUserLoggedIn()), voterID);
}

function getRecordFor(postID) {
    const logged = isUserLoggedIn();

    if (logged) {
        let loggedInValue = localStorage.getItem(localStorageKeyFactory(postID, true));

        if (loggedInValue) {
            return loggedInValue;
        }
    }

    return localStorage.getItem(localStorageKeyFactory(postID, false));
}

export function getVoteRecord(listicle) {
    const postID = listicle.dataset.postId;
    const record = getRecordFor(postID);
    return record;
}
